import ApplyLoan from "@Components/NewUI/ApplyLoan/ApplyLoan";
import AppyLoanEmi from "@Components/NewUI/ApplyLoan/AppyLoanEmi";
import NoData from "@Components/NewUI/Common/NoData";
import Kycnew from "@Components/NewUI/Common/kycnew";
import Kycnotdone from "@Components/NewUI/Common/kycnotdone";
import Kycprofileinreview from "@Components/NewUI/Common/kycprofileinreview";
import LoanHistory from "@Components/NewUI/LoanHistory/LoanHistory";
import LoanHistoryNoData from "@Components/NewUI/LoanHistory/LoanHistoryNoData";
import LoanStatusEMI from "@Components/NewUI/LoanHistory/LoanStatusEMI";
import LoanStatusLS from "@Components/NewUI/LoanHistory/LoanStatusLS";
import Notification from "@Components/NewUI/LoanHistory/Notification";
import Agreement from "@Components/NewUI/Pages/Agreement";
import AssigningNbfc from "@Components/NewUI/Pages/AssigningNbfc";
import ChangeMobileNumber from "@Components/NewUI/Pages/ChangeMobileNumber";
import CheckTicketHistory from "@Components/NewUI/Pages/CheckTicketHistory";
import ClosureRepay from "@Components/NewUI/Pages/ClosureRepay";
import CompleteYourProfile from "@Components/NewUI/Pages/CompleteYourProfile";
import DisburseSuccess from "@Components/NewUI/Pages/DisburseSuccess";
import DisbursingNbfc from "@Components/NewUI/Pages/DisbursingNbfc";
import ESign from "@Components/NewUI/Pages/ESign";
import KeyStatements from "@Components/NewUI/Pages/KeyStatements";
import LoanDetails from "@Components/NewUI/Pages/LoanDetails";
import LoanRepay from "@Components/NewUI/Pages/LoanRepay";
import LoanSuperAppDashboard from "@Components/NewUI/Pages/LoanSuperAppDashboard";
import Mandate from "@Components/NewUI/Pages/Mandate";
import ManualVerify from "@Components/NewUI/Pages/ManualVerify";
import NbfcAssigned from "@Components/NewUI/Pages/NbfcAssigned";
import NbfcAssignedMsg from "@Components/NewUI/Pages/NbfcAssignedmessage";
import NewPolicies from "@Components/NewUI/Pages/NewPolicies";
import InsuranceTC from "@Components/NewUI/Pages/InsuranceTc";
import ReviewLimit from "@Components/NewUI/Pages/ReviewLimit";
import Success from "@Components/NewUI/Pages/Success";
import VerifyWhatsApp from "@Components/NewUI/Pages/Whatsapp";
import DashboardSlider from "@Components/NewUI/User/DashboardSuperApp";
import ChangeYourMpin from "@Components/NewUI/User/ExistingUser/ChangeYourMpin";
import ForgetMpin from "@Components/NewUI/User/ExistingUser/ForgetMpin";
import NewSignIn from "@Components/NewUI/User/ExistingUser/NewSignIn";
import ResetMpin from "@Components/NewUI/User/ExistingUser/ResetMpin";
import SecurityPrivacy from "@Components/NewUI/User/ExistingUser/SecurityPrivacy";
import EmailVerify from "@Components/NewUI/User/NewUser/EmailVerify";
import NewSignUp from "@Components/NewUI/User/NewUser/NewSignUp";
// import NewUserEmailVerify from "@Components/NewUI/User/NewUser/NewUserEmail";
import PersonalLoanUserJourney from "@Components/NewUI/User/PersonalLoanUserJourney";
import ViewDetails from "@Components/NewUI/User/ViewDetails";
import ProfileMenu from "@Components/NewUI/UserProfile/ProfileMenu";
import ProfileMenuNew from "@Components/NewUI/UserProfile/ProfileMenuNew";
import ProfileView from "@Components/NewUI/UserProfile/ProfileView";
import { css } from "@emotion/react";
import React, { Suspense } from "react";
import { Navigate, Route, Routes as RouterRoutes } from "react-router-dom";
import { Loader } from "./helper/Loader";
import BankStatementUpload from "../src/Components/NewUI/Pages/BankStatementUpload";
import BankDetails from "../src/Components/NewUI/Pages/Bankstatement";
import OtherBank from "../src/Components/NewUI/Pages/otherBank";
import test from "../src/Components/NewUI/Pages/test";
import PaymeLearn from "@Components/NewUI/User/NewUser/SuperAppComponents/PaymeLearn";
import EmploymentDetail from "@Components/NewUI/ApplyLoan/EmploymentDetail";

const SetupAutoDebitNew = React.lazy(() =>

  import("./Components/NewUI/Pages/SetupAutoDebit")
);
const LoanDetailsFinals = React.lazy(() =>

  import("./Components/NewUI/Pages/Loan-detailsFinal.js")
);
const CompleteProfilenew = React.lazy(() =>

  import("./Components/NewUI/Profile/CompleteProfilenew")
);
const CompleteyourProfileScreenone = React.lazy(() =>

  import("./Components/NewUI/Profile/CompleteyourProfileScreenone")
);

const VerifyOtp = React.lazy(() =>

  import("./Components/NewUI/User/NewUser/VerifyOtp")
);
const VerifyOtpMobile = React.lazy(() =>

  import("./Components/NewUI/User/NewUser/VerifyOtpmobile")
);
const ExistingMobileVerify = React.lazy(() =>

  import("./Components/NewUI/User/NewUser/ExistingMobileVerify")
);
const VerifyOtpemail = React.lazy(() =>

  import("./Components/NewUI/User/NewUser/VerifyOtpemail")
);
const CreateMpin = React.lazy(() =>

  import("./Components/NewUI/User/NewUser/Mpin")
);
const CreditLimit = React.lazy(() =>

  import("./Components/NewUI/CibilForm/CreditLimit")
);
const Karza = React.lazy(() => 
  import("./Components/NewUI/CibilForm/karza"));
const Congratulation = React.lazy(() =>

  import("./Components/NewUI/CibilForm/CongratulationSuperApp")
);
const PlCongratulation = React.lazy(() =>

  import("./Components/NewUI/CibilForm/PlCongratulationSuperApp")
);
const LoanNotEligible = React.lazy(() =>

  import("./Components/NewUI/CibilForm/LoanNotEligible")
);
const RejectedLoan = React.lazy(() =>

  import("./Components/NewUI/CibilForm/RejectedLoan")
);
const Pancard = React.lazy(() => 
  import("./Components/NewUI/Ekyc/Pancard"));
const PanVerifyOtp = React.lazy(() => 
  import("./Components/NewUI/Ekyc/Otp"));
const AdharVerify = React.lazy(() =>

  import("./Components/NewUI/Ekyc/AdharVerify")
);
const LiveSelfie = React.lazy(() => 
  import("./Components/NewUI/Ekyc/Selfie"));

const AddBank = React.lazy(() =>
  import("./Components/NewUI/BankDetails/AddBank")
);

const ChangeBank = React.lazy(() =>

  import("./Components/NewUI/BankDetails/ChangeBank")
);


const NewUIDashboard = React.lazy(() =>

  import("./Components/NewUI/User/Dashboard")
);
const EkycWebView = React.lazy(() =>

  import("./Components/NewUI/Ekyc/EkycWebView")
);
const DummyDashboard = React.lazy(() =>

  import("./Components/NewUI/User/DummyDashboard")
);

const UpiPayment = React.lazy(() =>

  import("./Components/NewUI/Pages/UpiPayment")
);
const Sahamati = React.lazy(() => 
  import("./Components/NewUI/Pages/Sahamati"));
const PaymentSuccess = React.lazy(() =>

  import("./Components/NewUI/Pages/PaymentSuccess")
);
const PaymentFail = React.lazy(() =>

  import("./Components/NewUI/Pages/PaymentFail")
);
const Logo = React.lazy(() => 
  import("./Components/NewUI/Common/Logo"));

const LoanForeClosure = React.lazy(() =>

  import("./Components/NewUI/LoanForeclosure/LoanForeClosure")
);

const WithdrawLoan = React.lazy(() =>

  import("./Components/NewUI/WithdrawLoan/WithdrawLoan")
);
const AxisBankOffer = React.lazy(() =>

  import("@Components/NewUI/Pages/AxisBankOffer")
);
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  margin-top: 100px;
`;

export const Routes = () => {
  return (
    <div>
      <Suspense fallback={<Loader css={override} />}>
        <Logo />
        <RouterRoutes>
          <Route path="/test" element={<test />} />
          <Route path="/verifyOtp" element={<VerifyOtp />} />
          <Route path="/verifyOtpmoble" element={<VerifyOtpMobile />} />
          <Route path="/existingverifyOtpmoble" element={<ExistingMobileVerify />} />
          <Route path="/mpin" element={<CreateMpin />} />
          <Route path="/creditlimit" element={<CreditLimit />} />
          <Route path="/karza" element={<Karza />} />
          <Route path="/congratulation" element={<Congratulation />} />
          <Route path="/plcongratulation" element={<PlCongratulation />} />
          <Route path="/nbfc_message" element={<NbfcAssignedMsg />} />
          <Route path="/loan_repay" element={<LoanRepay />} />
          <Route path="/review-limit" element={<ReviewLimit />} />
          <Route path="/not_eligible_for_loan" element={<LoanNotEligible />} />
          <Route path="/rejected_loan" element={<RejectedLoan />} />
          <Route path="/pancard" element={<Pancard />} />
          <Route path="/panverifyotp" element={<PanVerifyOtp />} />
          <Route path="/adharverify" element={<AdharVerify />} />
          <Route path="/liveselfie" element={<LiveSelfie />} />
          <Route path="/add_bank_details" element={<AddBank />} />
          <Route path="/emailverify" element={<EmailVerify />} />
          <Route path="/emailotpverify" element={<VerifyOtpemail />} />
          <Route path="/verify_whatsapp" element={<VerifyWhatsApp />} />
          <Route path="/new_ui_dashboard" element={<NewUIDashboard />} />
          <Route path="/loanhistorynodata" element={<LoanHistoryNoData />} />
          <Route path="/loanhistory" element={<LoanHistory />} />
          <Route path="/loanstatusls" element={<LoanStatusLS />} />
          <Route path="/loanstatusemi" element={<LoanStatusEMI />} />
          <Route path="/notifications" element={<Notification />} />
          <Route path="/apply_loan" element={<ApplyLoan />} />
          <Route path="/" element={<NewSignIn />} />
          <Route path="/key-statements" element={<KeyStatements />} />
          <Route path="/bank_statement_upload" element={<BankStatementUpload />} />
          <Route path="/change_mobile_no" element={<ChangeMobileNumber />} />
          <Route path="/axis-bank" element={<AxisBankOffer />} />
          <Route path="/agreement" element={<Agreement />} />
          <Route path="/e-sign" element={<ESign />} />
          <Route path="/forget-mpin" element={<ForgetMpin />} />
          <Route path="/reset-mpin" element={<ResetMpin />} />
          <Route path="/success" element={<Success />} />
          <Route path="/mandate" element={<Mandate />} />
          <Route path="/loandetail" element={<LoanDetails />} />
          <Route path="/employment-details" element={<EmploymentDetail />} />
          <Route path="/loandetails" element={<LoanDetailsFinals />} />
          <Route path="/dashboard_s" element={<DashboardSlider />} />
          <Route path="/assigning_nbfc" element={<AssigningNbfc />} />
          <Route path="/nbfc_assigned" element={<NbfcAssigned />} />
          <Route path="/disburseloader" element={<DisbursingNbfc />} />
          <Route path="/disburse_success" element={<DisburseSuccess />} />
          <Route path="/manual_verify" element={<ManualVerify />} />
          <Route path="/bank_statement_option" element={<BankDetails />} />
          <Route path="/loan_foreclosure" element={<LoanForeClosure />} />
          <Route path="/withdraw_loan" element={<WithdrawLoan />} />
          <Route path="/complete_your_profile" element={<CompleteYourProfile />} />
          <Route path="/loan_closure_repay" element={<ClosureRepay />} />
          <Route path="/profile_menu" element={<ProfileMenu />} />
          <Route path="/profile_menu_new" element={<ProfileMenuNew />} />
          <Route path="/profile_view" element={<ProfileView />} />
          <Route path="/security_privacy" element={<SecurityPrivacy />} />
          <Route path="/change_mpin" element={<ChangeYourMpin />} />
          <Route path="/kycverifyinprogress" element={<Kycnew />} />
          <Route path="/kycprofileinreview" element={<Kycprofileinreview />} />
          <Route path="/kycnotdone" element={<Kycnotdone />} />
          <Route path="/chk_ticket_hist" element={<CheckTicketHistory />} />
          <Route path="/new_policies" element={<NewPolicies />} />
          <Route path="/insurance-tc" element={<InsuranceTC />} />
          <Route path="/no_data_found" element={<NoData />} />
          <Route path="/ekyc_webview" element={<EkycWebView />} />
          <Route path="/dummy-dashboard" element={<DummyDashboard />} />
          <Route path="/change_bank_details" element={<ChangeBank />} />
          <Route path="/upi-payment" element={<UpiPayment />} />
          <Route path="/upi-payment-success" element={<PaymentSuccess />} />
          <Route path="/upi-payment-fail" element={<PaymentFail />} />
          <Route path="/viewDetails" element={<ViewDetails />} />
          <Route path="/Sahamati" element={<Sahamati />} />
          <Route path="/super-loan-dashboard" element={<LoanSuperAppDashboard />} />
          <Route path="/applyloanemi" element={<AppyLoanEmi />} />
          <Route path="/personal_loan_emi" element={<PersonalLoanUserJourney />} />
          <Route path="/otherbank" element={<OtherBank />} />
          <Route path="/autodebit" element={<SetupAutoDebitNew />} />
          <Route path="/completeprofilenew" element={<CompleteProfilenew />} />
          <Route path="/completeprofilescreenone" element={<CompleteyourProfileScreenone />} />
          <Route path="/newsignup" element={<NewSignUp />} />
          <Route path="/payme-learn" element={<PaymeLearn />} />
          <Route path="/bank_details" element={<BankDetails />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </RouterRoutes>
      </Suspense>
    </div>
  );
};
